/**
 * Created by d.lolua on 12/13/2017.
 */
import mainePage from './mainPage.json'

export default {
    mainePage,
}


// WEBPACK FOOTER //
// ./src/locale/ka/index.js